module.exports = __webpack_public_path__ + "5d6fe38a57a81fbf2f9d2d8183e69e4e.woff2";